import HttpResponse from "../../../../../../utils/http/http.response";

export enum BillingsOrderForwardRelatedTaxiTaxiResponseContractBillingModel {
  ABA = "ABA",
  SABS = "SABS",
  AB = "AB",
  OTHER = "OTHER",
}

export enum BillingsOrderForwardRelatedTaxiTaxiResponseItemBillingStatus {
  CREATED = "CREATED",
  ACCEPTED = "ACCEPTED",
  REJECTED = "REJECTED",
  REOPEN_REQUEST = "REOPEN_REQUEST",
  REOPENED = "REOPENED",
}

export type BillingsOrderForwardRelatedTaxiTaxiResponseConsumerTaxi = {
  displayName: string;
};

export type BillingsOrderForwardRelatedTaxiTaxiResponseContract = {
  consumerTaxi: BillingsOrderForwardRelatedTaxiTaxiResponseConsumerTaxi;
  distanceRate: number;
  model: BillingsOrderForwardRelatedTaxiTaxiResponseContractBillingModel;
};

export type BillingsOrderForwardRelatedTaxiTaxiResponseCargoOrder = {
  humanId: number;
};

export type BillingsOrderForwardRelatedTaxiTaxiResponseTransportingOrder = {
  cargoOrder: BillingsOrderForwardRelatedTaxiTaxiResponseCargoOrder;
};

export type BillingsOrderForwardRelatedTaxiTaxiResponseOrderForwardingAction = {
  id: string;
  contract: BillingsOrderForwardRelatedTaxiTaxiResponseContract;
  transportingOrder: BillingsOrderForwardRelatedTaxiTaxiResponseTransportingOrder;
};

export type BillingsOrderForwardRelatedTaxiTaxiResponseItem = {
  id: string;
  draft: boolean;
  distance: number;
  amountForChargeHighways: number | null;
  amountForChargeHaltings: number | null;
  allContributionsAmount: number | null;
  amountForDistance: number | null;
  date: Date;
  orderForwardingAction: BillingsOrderForwardRelatedTaxiTaxiResponseOrderForwardingAction;
  sumOfBonuses: number;
  sumOfPenalties: number;
  status: BillingsOrderForwardRelatedTaxiTaxiResponseItemBillingStatus;
  readOnly: boolean;
};

type BillingsOrderForwardRelatedTaxiTaxiResponse = HttpResponse<
  BillingsOrderForwardRelatedTaxiTaxiResponseItem[]
>;

export default BillingsOrderForwardRelatedTaxiTaxiResponse;
